import Nullstack from 'nullstack';
export default function IconToiletPaper({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-toilet-paper",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("ellipse", {
    cx: "6",
    cy: "10",
    rx: "3",
    ry: "7"
  }), "   ", Nullstack.element("path", {
    d: "M21 10c0 -3.866 -1.343 -7 -3 -7"
  }), "   ", Nullstack.element("path", {
    d: "M6 3h12"
  }), "   ", Nullstack.element("path", {
    d: "M21 10v10l-3 -1l-3 2l-3 -3l-3 2v-10"
  }), "   ", Nullstack.element("path", {
    d: "M6 10h.01"
  }), " ");
}